/* eslint-disable */
<template>
  <div>
    <multiselect @input="onChangeSelect($event)" v-model="value" :options="options" :searchable="false"
                 :close-on-select="true" :show-labels="false" :placeholder="placeholder"
                 track-by="value" label="label"
                 :preselect-first="true"
                 :allowEmpty="false"
                 @select="onChangeSelect($event)">
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <div class="myselectoption">
            <div class="optioncheckbox">
              <div class="checkbox__box-selected" style="display: none"></div>
            </div>
            <span class="option__title">{{ props.option.label }}</span>
          </div>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

// var myoptions;
export default {

  components: {Multiselect},
  // props: {
  //
  // },
  // watch: {
  //   // options: function(newVal, oldVal) {
  //   //   console.log('Prop changed: ', newVal, ' | was: ', oldVal);
  //   //   console.log("VALUE", this.$data.value);
  //   //   for (var i = 0; i < newVal.length; ++i)
  //   //   {
  //   //     console.log("value",newVal[i].value );
  //   //   }
  //   //   this.$data.value = {value: "peter", label:"Peter"};
  //   //   this.$emit('changeSelect', {value: "peter", label:"Peter"})
  //   // },
  // },
  data()
  {
    return {
      value: null,
      options: [],
      placeholder: "Please select",
      currentValue: "",
      firstInit: true,
      disabled: false
    }
  },
  methods: {
    onChangeSelect(event)
    {
      this.$data.currentValue = event.value;
      this.$emit('changeSelect', event)

    },
    setOptions: function (options) {
      this.$data.options = options;
      // myoptions = options;
      var test = false;
      // console.log("this.$data.currentValue", this.$data.currentValue);
      for (var i = 0; i < options.length; ++i)
      {
        if (this.$data.currentValue == options[i].value)
        {
          test = true;
          break;
        }
      }
      if(test === false) this.$data.value = null;
      if(options.length == 1 || this.$data.firstInit == true)
      {
        this.$data.value = {"label":options[0].label, "value":options[0].value};
        this.$data.firstInit = false;
      }

    },
    setPlaceholder: function (placeholder) {
      this.$data.placeholder = placeholder;
    },
    setSelected: function(newVal) {
      // console.log("this.$data.options", this.$data.options);
      for (var i = 0; i < this.$data.options.length; ++i)
      {
        // console.log("value", newVal + " - " + this.$data.options[i].value+": "+this.$data.options[i].label);
        if (this.$data.options[i].value == newVal)
        {
          this.$data.value = {value: newVal, label:this.$data.options[i].label};
          // this.$emit('changeSelect', {value: newVal, label:this.$data.options[i].label});
          break;
        }
      }
    },
    setDisabled: function (val) {
      this.$data.disabled = val;
    },
    isDisabled: function () {
      return this.$data.disabled;
    },
    setDisabledOption: function (index, val) {
      try {
        if (val == true)
        {
          this.$data.options[index].$isDisabled = true;
        } else
        {
          delete this.$data.options[index].$isDisabled;
        }
      }catch (e) {
        return null;
      }

    },
    isDisabledOption: function (index) {
      return this.$data.options[index].$isDisabled == true?true:false;
    },
    val: function () {
      // return this.$data.currentValue;
      return this.$data.value == null ? "":this.$data.value.value;
    },
    eqval: function (index) {
      // return this.$data.currentValue;
      // console.log("eqval", this.options);
      // console.log("eqval index", index);
      // return this.$data.options[index].value;
      // return  myoptions[index].value;
      try {
        return  this.$data.options[index].value;
      } catch (e) {
        return "";
      }

      // return this.options[index].value;
    },
    label: function () {
      return this.$data.value == null ? "":this.$data.value.label;
    },
    index: function () {
      for (var i = 0; i < this.$data.options.length; ++i)
      {
        if (this.$data.currentValue == this.$data.options[i].value)
        {
          return i;
        }
      }
    }
  }
}
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style>
.multiselect__tags {
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #f0f0f0;
  border: 0.1875rem solid #f0f0f0;
  border-radius: 0;
  display: block;
  font-family: DINNextLTW05-Regular, sans-serif;
  font-size: 18px !important;
  /* font-size: 12px; */
  /*height: 2.5rem;*/
  padding: 0.3125rem 2.375rem 0.3125rem calc(0.1875rem + 0.3125rem);
  width: 100%;
  outline: none;
  cursor: pointer;
}
.multiselect__select {
  transition: none;
}
.multiselect--active .multiselect__select {
  transform: unset;
}
.multiselect--active .multiselect__select:before {
  transform: rotate(180deg);
}
.multiselect__select:before {
  content: "";
  display: block;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 7.6l-6-6L1.6 0 6 4.4 10.4 0 12 1.6l-6 6z' fill='%2333ADFF' fill-rule='evenodd'/%3E%3C/svg%3E");
  background-position: center;
  background-size: 0.75rem 0.5rem;
  background-repeat: no-repeat;
  height: 2.5rem;
  pointer-events: none;
  position: absolute;
  right: 1rem;
  top: -4px;
  width: 0.75rem;
  border: 0;
}
.myselectoption {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.option__desc {
  padding: 8px 0;
  margin: 0 16px;
  font-family: DINNextLTW01-Medium;
  border-bottom: 1px solid #f0f0f0;

}
.optioncheckbox {
  background: #f0f0f0;
  height: 20px;
  width: 20px;
  border: 1px solid #e0dede;
  margin-right: 6px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.checkbox__box-selected {
  height: 9px;
  width: 9px;
  background: #4aacf8;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.multiselect__option {
  padding:0;
  display: flex;
  align-content: center;
}
.multiselect__option > span {
  padding-top:12px;
}
.multiselect__option:before{
  margin-left:10px;
  margin-right:10px;
  margin-top:10px;
  font-family: DINNextLTW01-Medium;
  content:url('../assets/icon_select_unselected.png')
}
.multiselect__option--selected:before{
  content:url('../assets/icon_select_selected.png')
}
.multiselect__option--highlight {
  background: unset;
  outline: none;
  color: #000;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: unset;
  color: #000;
}
.multiselect__option--selected  .checkbox__box-selected{
  display: block !important;
}
.multiselect__option--selected {
  background: unset;
  color: unset;
  /*font-weight: 700;*/
}
.multiselect__input, .multiselect__single {
  background: unset;
  vertical-align: unset;
  margin-bottom: 0 !important;
}
.multiselect__single {
  cursor: pointer;
}
.multiselect__placeholder {
  color: #000;
}
.multiselect {
  color:#000;
  margin-top:8px;
}
</style>